import React from 'react'
import { DateInput } from 'semantic-ui-calendar-react'
import { useAuth } from '~/routes/components/AuthProvider'
import styled from 'styled-components'

const FilterWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
`

interface Props {
  checkedFilters: any[]
  dataFiltered: any
  onChangeDataFiltered: (data: any) => void
}

const Filters: React.FC<Props> = (props) => {
  const { systemData: { languages, logged: { languageId } } } = useAuth()
  const languageLocal = languages.find(language => language.id === languageId)

  const { checkedFilters, dataFiltered, onChangeDataFiltered } = props

  const handleKeyPress = (event) => {
    event.preventDefault()
  }

  return <FilterWrapper>
    {checkedFilters.map(filter => (
      <React.Fragment key={filter.key}>
        <DateInput
          name={filter.fromKey}
          autoComplete='off'
          placeholder={filter.fromPlaceholder}
          closable
          clearIcon={'close'}
          clearable
          localization={languageLocal.code}
          onKeyPress={handleKeyPress}
          closeOnMouseLeave={false}
          dateFormat={'DD.MM.YYYY'}
          className={'datePicker'}
          value={dataFiltered[filter.fromKey] || ''}
          iconPosition='left'
          onChange={(e, data) => onChangeDataFiltered({
            ...dataFiltered,
            [filter.fromKey]: data.value,
            page: 0
          })}
        />
        <DateInput
          name={filter.toKey}
          autoComplete='off'
          placeholder={filter.toPlaceholder}
          closable
          clearIcon={'close'}
          clearable
          localization={languageLocal.code}
          onKeyPress={handleKeyPress}
          closeOnMouseLeave={false}
          dateFormat={'DD.MM.YYYY'}
          className={'datePicker'}
          minDate={dataFiltered[filter.fromKey] || ''}
          value={dataFiltered[filter.toKey] || ''}
          iconPosition='left'
          onChange={(e, data) => onChangeDataFiltered({
            ...dataFiltered,
            [filter.toKey]: data.value,
            page: 0
          })}
        />
      </React.Fragment>
    ))}
  </FilterWrapper>
}
export default Filters
